/**
 * CompletenessHint Component
 * Shows icon status indicators and encouragement text above the submit button
 */

import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { Text, View } from 'react-native';

export interface CompletenessHintProps {
  /** Whether the user has added at least one photo */
  hasPhotos: boolean;
  /** Whether the user has written a review */
  hasReview: boolean;
  /** Whether the hint should be visible */
  visible: boolean;
}

function getEncouragementText(hasPhotos: boolean, hasReview: boolean): string | null {
  if (hasPhotos && hasReview) return null;
  if (!hasPhotos && !hasReview) return 'A photo and review help your check-in stand out';
  if (hasPhotos) return 'Add a review to share your thoughts';
  return 'A photo brings your check-in to life';
}

export function CompletenessHint({ hasPhotos, hasReview, visible }: CompletenessHintProps) {
  if (!visible) return null;

  const encouragement = getEncouragementText(hasPhotos, hasReview);

  return (
    <View className="mb-3">
      <View className="flex-row items-center justify-center gap-5">
        <View className="flex-row items-center gap-1.5">
          <Ionicons
            name={hasPhotos ? 'checkmark' : 'camera-outline'}
            size={14}
            className={hasPhotos ? 'text-primary' : 'text-muted-foreground'}
          />
          <Text className={`text-xs ${hasPhotos ? 'text-primary' : 'text-muted-foreground'}`}>
            Photo
          </Text>
        </View>
        <View className="flex-row items-center gap-1.5">
          <Ionicons
            name={hasReview ? 'checkmark' : 'chatbubble-outline'}
            size={14}
            className={hasReview ? 'text-primary' : 'text-muted-foreground'}
          />
          <Text className={`text-xs ${hasReview ? 'text-primary' : 'text-muted-foreground'}`}>
            Review
          </Text>
        </View>
      </View>
      {encouragement && (
        <Text className="text-xs text-muted-foreground text-center mt-1.5">
          {encouragement}
        </Text>
      )}
    </View>
  );
}

export default CompletenessHint;
